import { Box, Image, SpacerNew, Text, useWindowDimensions } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const About = () => {
  const resPadding = usePadding()
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  return (
    <Box ph={resPadding} flexDirection={isMob ? 'column' : 'row'} pv={isMob ? 120 : 216}>
      <Box f={isMob ? undefined : 0.5}>
        <Image
          source={require('../../assets/images/about-jiopay.png')}
          width={'100%'}
          height={isMob ? 320 : '100%'}
          resizeMode={'contain'}
        />
      </Box>
      <Box f={isMob ? undefined : 0.5} flexDirection={'column'} pt={isMob ? 56 : 0}>
        <Text
          title={'About JioPay'}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 32 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          color={'BLACK_21'}
          textAlign={isMob ? 'center' : 'auto'}
        />
        <SpacerNew size={isMob ? 16 : 32} />
        <Box marginRight={isMob ? 0 : '16%'}>
          <Text
            title={staticStrings.aboutSubTitle}
            fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
            fontSize={isMob ? 14 : 24}
            lineHeight={isMob ? 20 : 40}
            letterSpacing={isMob ? 0 : -0.48}
            color={isMob ? 'PRIMARY_GREY' : 'BLACK_21'}
            textAlign={isMob ? 'center' : 'auto'}
          />
        </Box>
        <SpacerNew size={80} />
        <Text
          title={'How do you use JioPay?'}
          fontFamily={'jiotype-black'}
          fontSize={isMob ? 24 : 64}
          lineHeight={isMob ? 32 : 80}
          letterSpacing={isMob ? 0 : -2.5}
          color={'BLACK_21'}
          textAlign={isMob ? 'center' : 'auto'}
        />
        <SpacerNew size={isMob ? 16 : 32} />
        <Box marginRight={isMob ? 0 : '16%'}>
          <Text
            title={staticStrings.howToSubTitle}
            fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
            fontSize={isMob ? 14 : 24}
            lineHeight={isMob ? 20 : 40}
            letterSpacing={isMob ? 0 : -0.48}
            color={isMob ? 'PRIMARY_GREY' : 'BLACK_21'}
            textAlign={isMob ? 'center' : 'auto'}
          />
        </Box>
      </Box>
    </Box>
  )
}
